module.exports = __webpack_public_path__ + "img/27.dcea03aa.jpg";